<div class="page-container">
  <div *ngIf="loading()" class="loading-state">
    <div class="spinner"></div>
    <p>Loading page data...</p>
  </div>

  <div *ngIf="error() && !loading()" class="error-state">
    <p class="error-message">Error: {{ error() }}</p>
  </div>

  <div *ngIf="!loading() && !error()" class="page-content">
    <div class="layouts-container" *ngIf="layouts.length > 0">
      <div *ngFor="let layout of layouts" class="layout-section">
        <jepto-layout-container
          [layout]="layout"
          [accountId]="accountId()"
          [viewId]="viewId()"
          [themeMode]="theme()"
          [palette]="palette()"
          [themeConfig]="themeConfig()"
          [layoutOptions]="layoutOptions()"
          [staticGrid]="viewOnly()"
          [reportDateRangeExpression]="reportDateRangeExpression()"
          (filterDateRangeChange)="filterDateRangeChange.emit($event)"
        >
        </jepto-layout-container>
      </div>
    </div>
  </div>
</div>
